import type { Highlight } from '../../interface/Program';
import type { Paginated } from '@/interfaces/Paginate';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getHighlightedContents = async (url: string) => {
  const { data } = await api.get<Paginated<HighlightedContentsAPIResponse>>(
    url,
    { params: { page: 1, limit: 10 } }
  );

  return data.data;
};

export const useGetHighlightedContents = (context: Context) => {
  const { data: session } = useSession();

  const url =
    session && session.access_token
      ? mapContext[context]
      : mapContextPublic[context];

  return useQuery({
    queryKey: ['highlighted', 'contents', url],
    queryFn: () => getHighlightedContents(url),
  });
};

type HighlightedContentsAPIResponse = {
  id: string;
  items: Highlight[];
  title: string;
};

const mapContext = {
  home: apiConfig.routes.home.highlights,
  research: apiConfig.routes.research.highlights,
} as const;

const mapContextPublic = {
  home: apiConfig.routes.home.highlightsPublic,
  research: apiConfig.routes.research.highlightsPublic,
} as const;

type Context = keyof typeof mapContext;
